import { CheckboxCard as MatchboxCheckboxCard } from '@sparkpost/matchbox';

export default MatchboxCheckboxCard;
